import React, { useState, useEffect } from 'react';
import s from './ArtistList.module.css';
import images from '../../assets/hero/index';
import ModalArtist from './ModalArtist/ModalArtist';
import { useMediaQuery } from 'react-responsive';

const ArtistList = () => {
  const [artists, setArtists] = useState([]);
  const [page, setPage] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [id, setId] = useState(false);
  const [sorting, setSorting] = useState('');
  const [genre, setGenre] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [isSearch, setIsSearch] = useState(0);
  const [isSeeMore, setIsSeeMore] = useState(true);
  const [open, setOpen] = useState(false);
  const isDesktop = useMediaQuery({ query: '(min-width:1440px)' });

  function handleSorting(e) {
    setSorting(e.target.value);
    setPage(1);
    setIsSeeMore(true);
  }
  function handleGenre(e) {
    setGenre(e.target.value);
    setPage(1);
    setIsSeeMore(true);
  }
  function handleSearchQuery(e) {
    setSearchQuery(e.target.value);
  }
  useEffect(() => {
    let url = `https://sound-wave.b.goit.study/api/artists?limit=10&page=${page}`;
    if (sorting) url += `&sortName=${sorting}`;
    if (genre) url += `&genre=${genre}`;
    if (isSearch) url += `&name=${searchQuery}`;

    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (data.totalArtists <= 10 * page) {
          setIsSeeMore(false);
        }
        setArtists(prev => {
          return page === 1 ? data.artists : [...prev, ...data.artists];
        });
      });
  }, [page, sorting, genre, isSearch]);

  function onSubmit(e) {
    e.preventDefault();
    setPage(1);
    setIsSearch(prev => prev + 1);
    setIsSeeMore(true);
  }

  function onReset(e) {
    setSorting('');
    setGenre('');
    setPage(1);
    setSearchQuery('');
    setIsSearch(0);
    setIsSeeMore(true);
  }

  const allGenres = artists.flatMap(artist => artist.genres);

  return (
    <div className={s.section}>
      <div className="container">
        <p className={s.span}>Artists</p>
        <h2 className={s.sectionTitle}>Explore Your New Favorite Artists</h2>
        <div className={s.artistsWrapDesktop}>
          <div className={s.filtersHeader}>            
            {/* tablet and phone filters*/}
            {/* tablet and phone filters*/}
            {/* tablet and phone filters*/}
            {!isDesktop && (
              <div>
                <p className={s.filtersText}>Filters</p>
                <button
                  className={s.openFilters}
                  onClick={() => setOpen(!open)}
                >
                  Search and Filters
                  {open ? (
                    // Стрілка вгору
                    <svg
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0 5.707L1.414 7.121L5.707 2.828L10 7.121L11.414 5.707L5.707 0L0 5.707Z"
                        fill="white"
                      />
                    </svg>
                  ) : (
                    // Стрілка вниз
                    <svg
                      width="12"
                      height="8"
                      viewBox="0 0 12 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 0L5.707 4.293L1.414 0L0 1.414L5.707 7.121L11.414 1.414L10 0Z"
                        fill="white"
                      />
                    </svg>
                  )}
                </button>
                {open && (
                  <div className={s.filters}>
                    <form onSubmit={onSubmit} className={s.search}>
                      <img src={images.search} alt="search" />
                      <input
                        className={s.input}
                        type="text"
                        onChange={handleSearchQuery}
                        placeholder="Search"
                        value={searchQuery}
                      />
                    </form>

                    <select
                      className={s.select}
                      name="sorting"
                      onChange={handleSorting}
                      value={sorting}
                    >
                      <option value="" className={s.selectOption}>
                        Default
                      </option>
                      <option value="asc">A-Z</option>
                      <option value="desc">Z-A</option>
                    </select>

                    <select
                      className={s.select}
                      name="genre"
                      value={genre}
                      onChange={handleGenre}
                    >
                      <option value="">Genre</option>
                      <option value="Pop">Pop</option>
                      <option value="Rock">Rock</option>
                      {/* <option value="R&B">R&B</option> R&B ERROR*/}
                      <option value="Urban">Urban</option>
                      <option value="Hip-Hop">Hip-Hop</option>
                      <option value="Rap">Rap</option>
                      <option value="Rock/Pop">Rock/Pop</option>
                      <option value="Alternative Rock">Alternative Rock</option>
                      <option value="Metal">Metal</option>
                      <option value="Ambient">Ambient</option>
                      <option value="Heavy Metal">Heavy Metal</option>
                      <option value="Electronic">Electronic</option>
                      <option value="Experimental">Experimental</option>
                      <option value="Classical">Classical</option>
                      <option value="Composer">Composer</option>
                      <option value="Post-Rock">Post-Rock</option>
                      <option value="New Age">New Age</option>
                      <option value="Indie">Indie</option>
                      <option value="Blues">Blues</option>
                      <option value="Jazz">Jazz</option>
                      <option value="Rock & Roll">Rock & Roll</option>
                      <option value="Country">Country</option>
                      <option value="Soul">Soul</option>
                      <option value="Britpop">Britpop</option>
                      <option value="Folk">Folk</option>
                      <option value="Grunge">Grunge</option>
                      <option value="Indie Pop">Indie Pop</option>
                      <option value="Psychedelic Rock">Psychedelic Rock</option>
                      <option value="Punk Rock">Punk Rock</option>
                      <option value="Hard Rock">Hard Rock</option>
                      <option value="Industrial Metal">Industrial Metal</option>
                      <option value="Pop-Punk">Pop-Punk</option>
                      <option value="Thrash Metal">Thrash Metal</option>
                      <option value="Alternative Metal">
                        Alternative Metal
                      </option>
                      <option value="Progressive Metal">
                        Progressive Metal
                      </option>
                    </select>
                  </div>
                )}
                <div className={s.bntResetWrap}>
                  <button onClick={onReset} className={s.btnReset}>
                    Reset filters
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* tablet and phone filters*/}
          {/* tablet and phone filters*/}
          {/* tablet and phone filters*/}

          {/* desktop filters and btn reset*/}
          {/* desktop filters and btn reset*/}
          {/* desktop filters and btn reset*/}
          {isDesktop && (
            <div className={s.filtersDesktop}>
              <div className={s.filtersHeaderDesktop}>
                <p className={s.filtersText}>Filters</p>
                <div className={s.bntResetWrap}>
                    <button onClick={onReset} className={s.btnResetDesktop}>
                      Reset filters
                    </button>
                </div>
              </div>
              <form onSubmit={onSubmit} className={s.searchDesktop}>
                <img src={images.search} alt="search" />
                <input
                  className={s.inputDesktop}
                  type="text"
                  onChange={handleSearchQuery}
                  placeholder="Search"
                  value={searchQuery}
                />
              </form>
              <select
                className={s.selectDesktop}
                name="sorting"
                onChange={handleSorting}
                value={sorting}
              >
                <option value="" className={s.selectOptionDesktop}>
                  Default
                </option>
                <option value="asc">A-Z</option>
                <option value="desc">Z-A</option>
              </select>
              <select
                className={s.selectDesktop}
                name="genre"
                value={genre}
                onChange={handleGenre}
              >
                <option value="">Genre</option>
                <option value="Pop">Pop</option>
                <option value="Rock">Rock</option>
                {/* <option value="R&B">R&B</option> R&B ERROR*/}
                <option value="Urban">Urban</option>
                <option value="Hip-Hop">Hip-Hop</option>
                <option value="Rap">Rap</option>
                <option value="Rock/Pop">Rock/Pop</option>
                <option value="Alternative Rock">Alternative Rock</option>
                <option value="Metal">Metal</option>
                <option value="Ambient">Ambient</option>
                <option value="Heavy Metal">Heavy Metal</option>
                <option value="Electronic">Electronic</option>
                <option value="Experimental">Experimental</option>
                <option value="Classical">Classical</option>
                <option value="Composer">Composer</option>
                <option value="Post-Rock">Post-Rock</option>
                <option value="New Age">New Age</option>
                <option value="Indie">Indie</option>
                <option value="Blues">Blues</option>
                <option value="Jazz">Jazz</option>
                <option value="Rock & Roll">Rock & Roll</option>
                <option value="Country">Country</option>
                <option value="Soul">Soul</option>
                <option value="Britpop">Britpop</option>
                <option value="Folk">Folk</option>
                <option value="Grunge">Grunge</option>
                <option value="Indie Pop">Indie Pop</option>
                <option value="Psychedelic Rock">Psychedelic Rock</option>
                <option value="Punk Rock">Punk Rock</option>
                <option value="Hard Rock">Hard Rock</option>
                <option value="Industrial Metal">Industrial Metal</option>
                <option value="Pop-Punk">Pop-Punk</option>
                <option value="Thrash Metal">Thrash Metal</option>
                <option value="Alternative Metal">Alternative Metal</option>
                <option value="Progressive Metal">Progressive Metal</option>
              </select>
            </div>
          )}

          {/* desktop filters and btn reset*/}
          {/* desktop filters and btn reset*/}
          {/* desktop filters and btn reset*/}
          <ul className={s.artistsListWrap}>
            {artists.length > 0 &&
              artists.map(artist => {
                return (
                  <li className={s.ArtistList}>
                    <img src={artist.strArtistThumb} className={s.strImg}></img>
                    <ul className={s.genresList}>
                      {artist.genres.map(genre => {
                        return <li className={s.genre}>{genre}</li>;
                      })}
                    </ul>
                    <p className={s.artistsName}>{artist.strArtist}</p>
                    <p className={s.artistsDescription}>
                      {artist.strBiographyEN}
                    </p>
                    <button
                      className={s.learnMore}
                      onClick={() => { 
                        document.body.style.overflow = 'hidden';
                        setId(artist._id);
                        setModalOpen(!modalOpen);
                      }}
                    >
                      Learn More <img src={images.caret_right} />
                    </button>
                  </li>
                );
              })}
          </ul>        
        </div>
        {isSeeMore && (
          <div className={s.loadMoreWrap}>
            <button
              className={s.loadMore}
              onClick={() => {
                setPage(page + 1);
              }}
            >
              Load More <img src={images.down_arrow_alt} />
            </button>
          </div>
        )}
      </div>
      {modalOpen && (
        <ModalArtist id={id} setModalOpen={setModalOpen}></ModalArtist>
      )}
    </div>
  );
};

export default ArtistList;
